module.exports = __webpack_public_path__ + "img/20190911163733666.480dc0c6.jpg";